export const stringMapDefault = {
    ariaLabelClearIcon: "Clear",
    ariaLabelTriggerIcon: "Open Color Picker",
    ariaLabelUndoIcon: "Undo",
    clearTooltip: "Clear",
    colorSwatchTooltip: "Select Color",
    errorMessage: "Error",
    resetTooltip: "Reset"
};
